"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKProvider = exports.SDKContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var app_sdk_1 = require("@contentful/app-sdk");
var react_1 = require("react");
exports.SDKContext = (0, react_1.createContext)({ sdk: null });
var DELAY_TIMEOUT = 4 * 1000;
/**
 * The Component providing the AppSdk, the useSDK hook can only be used within this Provider
 * @param props.loading an optional loading element that gets rendered while initializing the app
 */
var SDKProvider = function (props) {
    var _a = (0, react_1.useState)(), sdk = _a[0], setSDK = _a[1];
    (0, react_1.useEffect)(function () {
        var timeout = window.setTimeout(function () {
            console.warn("Your app is taking longer than expected to initialize. If you think this is an error with Contentful's App SDK, let us know: https://github.com/contentful/ui-extensions-sdk/issues");
        }, DELAY_TIMEOUT);
        (0, app_sdk_1.init)(function (sdk) {
            setSDK(sdk);
            window.clearTimeout(timeout);
        });
        return function () { return window.clearTimeout(timeout); };
    }, []);
    if (!sdk) {
        if (props.loading) {
            return props.loading;
        }
        return null;
    }
    return (0, jsx_runtime_1.jsx)(exports.SDKContext.Provider, __assign({ value: { sdk: sdk } }, { children: props.children }));
};
exports.SDKProvider = SDKProvider;
